import { GQSPayload } from "@p81-common/shell-core-js";
import * as actions from "./updatableObjectsActions";
import { UpdatableObject } from "./types";
import { Operator } from "types";

export type UpdatableObjectFilterType = "internetAccess" | "splitTunneling";

export interface UpdatableObjectsGetRequestAction {
  type: typeof actions.UPDATABLE_OBJECTS_GET_REQUEST;
  filterType?: UpdatableObjectFilterType;
}

export function getRequestPayload(page: number, filterType: UpdatableObjectFilterType = "splitTunneling"): GQSPayload {
  return {
    entityName: "UpdatableObject",
    fields: [
      "vendorId",
      "vendorParentId",
      "vendorChildrenIds",
      "isRoot",
      "name",
      "description",
      "infoText",
      "infoUrl",
      "inheritDescription",
      "inheritInfoText",
      "inheritInfoUrl",
      "cpId",
      "dataObjectsCount",
      "type",
    ],
    page,
    itemsPerPage: 500,
    sort: { field: "name", direction: "asc" },
    requireTenantId: false,
    valuesFilter: {
      [`type.${filterType}`]: {
        values: [true],
        operator: Operator.EQUAL,
      },
    },
  };
}

export function updateInfoData(obj: UpdatableObject, vendorParentId: UpdatableObject["vendorParentId"], vendorMap: Map<UpdatableObject["vendorId"], UpdatableObject>) {
  const parent = vendorMap.get(vendorParentId);
  if (!parent) return;

  const fields = [
    ["inheritDescription", "description"],
    ["inheritInfoText", "infoText"],
    ["inheritInfoUrl", "infoUrl"],
  ];

  let needsRecursiveCall = false;

  for (const [inheritKey, valueKey] of fields) {
    if (obj[inheritKey] && parent[valueKey]) {
      obj[valueKey] = parent[valueKey];
      delete obj[inheritKey];
    } else if (obj[inheritKey]) {
      needsRecursiveCall = true;
    }
  }

  if (needsRecursiveCall && parent.vendorParentId) {
    updateInfoData(obj, parent.vendorParentId, vendorMap);
  }
}
